export default __webpack_public_path__ + "static/media/aw.98298192.svg";